import React from 'react';
import styled, { keyframes } from 'styled-components';
import { animated } from 'react-spring';

import { IRotations, DirectionType } from '../../types';

import { CorrectAnswer, FalseAnswer } from '../../svg';
import { LandholdC } from './LandholdC';

const fadeInOut = keyframes`
    0% {
        opacity: 0;
    }
    15% {
        opacity: 1;
    }
    65% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        }
`;

const Wrapper = styled(animated.div)`
    display: flex;
    align-items: center;
    flex: 1;
    max-height: 400px;
`;

interface IProps {
    className?: string;
    currentAnswer: boolean | null;
    currentTestSizePx: number;
    direction?: DirectionType;
    style?: React.CSSProperties;
}

const rotations: IRotations = {
    up: '-90deg',
    down: '90deg',
    right: 'none',
    left: '180deg',
};

export const BaseLandholtDisplay = ({
    className,
    currentAnswer,
    currentTestSizePx,
    direction,
    style,
}: IProps) => (
    <Wrapper className={className} style={{ ...style }}>
        {currentAnswer && <CorrectAnswer />}
        {direction && (
            <LandholdC
                size={currentTestSizePx}
                rotation={rotations[direction]}
            />
        )}
        {currentAnswer === false && <FalseAnswer />}
    </Wrapper>
);

export const LandholtDisplay = styled(BaseLandholtDisplay)`
    ${CorrectAnswer}, ${FalseAnswer} {
        position: absolute;
        height: 40px;
        width: 40px;
        margin: 20px;
        animation: 1.5s ${fadeInOut} ease-out;
        animation-fill-mode: forwards;
    }

    ${CorrectAnswer} {
        left: -100px;
    }

    ${FalseAnswer} {
        right: -100px;
    }
`;
